'use client';

import { twMerge } from 'tailwind-merge';

import { inventoryItemMinWidth, maxSlidesInInventorySlider } from '@/constants/inventory';
import { SliderInventory } from '@lamesarv-sdk/inventory';
import { convertSort } from '@lamesarv-sdk/tools';

import { IComponentSliderInventory, InventoryField } from '@lamesarv-sdk/types';

import { InventoryItem } from './InventoryItem';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';

interface InventorySliderExtraData {
  title?: string;
  cta_text?: string;
  cta_link?: string;
  classes_title?: string;
  classes_cta?: string;
  sort?: string;
}

export const InventorySlider = ({ className, ...props }: IComponentSliderInventory) => {
  const { title, cta_text, cta_link, classes_title, classes_cta, sort } = (props.extraData ||
    {}) as InventorySliderExtraData;
  const convertedSort = !!sort ? convertSort(sort) : undefined;

  return (
    <div className={twMerge('grid grid-cols-1 my-8 md:my-16', className)}>
      {title && (
        <h2
          className={twMerge(
            'font-helvetica text-black-500 text-xl lg:text-[1.75rem] font-bold mb-6 lg:mb-8 place-self-center',
            classes_title,
          )}
        >
          {title}
        </h2>
      )}

      <SliderInventory
        {...props}
        sort={convertedSort || `${InventoryField.order}:asc`}
        CustomInventoryItem={InventoryItem}
        minSlideWidth={inventoryItemMinWidth}
        maxSlides={maxSlidesInInventorySlider}
      />

      {cta_text && (
        <Link
          href={cta_link || '#'}
          className={twMerge(
            'font-helvetica mt-10 md:mt-12 place-self-center py-3 lg:py-4 px-7 lg:px-8 rounded bg-white border border-blue-500 text-blue-500 text-sm md:text-base font-bold flex items-center gap-3 hover:bg-blue-50',
            classes_cta,
          )}
        >
          <span>{cta_text}</span>
          <FontAwesomeIcon icon={faArrowRight} className="size-4 md:size-5" />
        </Link>
      )}
    </div>
  );
};
